<template>
    <b-container fluid>
        <div class="d-flex justify-content-center mb-5">
            <!-- <b-img src="img/banner_vecindapp.png"></b-img> -->
            <b-img :src="getBanner()"></b-img>
        </div>
        <b-row v-for="workplace in workplaces" :key="workplace.id" class="mt-3">
            <b-col>
                <b-btn block variant="primary" @click="selectWorkplace(workplace)"
                    >{{ workplace.name }} - {{ workplace.venue.name }} - {{ workplace.venue.unit.name }}</b-btn
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="sizeWorkplaces">
                <b-alert show variant="warning">No tiene ningun puesto de trabajo asociado.</b-alert>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapMutations } from 'vuex'
import * as mutations from '@store/_mutations'
export default {
    data: () => ({
        workplaces: [],
        sizeWorkplaces: '',
    }),
    computed: {},
    methods: {
        ...mapMutations({
            setCurrentWorkplace: mutations.SET_CURRENT_WORKPLACE,
            setCurrentUnit: mutations.SET_CURRENT_UNIT,
            setCurrentVenue: mutations.SET_CURRENT_VENUE,
            setCurrentClient: mutations.SET_CURRENT_CLIENT,
        }),
        async loadWorkplaces() {
            const { data } = await this.$repo.get(`users/${this.currentUser.id}/workplaces`, {
                venueId: this.currentVenue.id,
            })
            if (data.length === 1) {
                return this.selectWorkplace(data[0])
            }
            this.workplaces = data

            if (this.workplaces.length === 0) {
                this.sizeWorkplaces = true
            }
        },
        selectWorkplace(workplace) {
            this.setCurrentWorkplace(workplace)
            this.$router.push({ name: 'startShift' })
        },
        getBanner() {
            if (!this.isReseller) return 'img/banner_vecindapp.png'

            return !!this.currentClient && !!this.currentClient.banner_url ? this.currentClient.banner_url : 'img/banner_vecindapp.png'
        },
    },
    mounted() {
        this.loadWorkplaces()
    },
}
</script>
